module.exports = __webpack_public_path__ + "img/button_page up.66dd39f2.png";